import PARENT from '../types';

const GRAPHICAL_STATISTICS = `${PARENT}/GRAPHICAL_STATISTICS`;

export const RESET_GRAPHICAL_STATISTICS = `${GRAPHICAL_STATISTICS}/RESET`;

export default GRAPHICAL_STATISTICS;
